import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import queryClient from '../utilities/queryClient.ts';

const CUSTOMER_LOCATION_ID_KEY = 'CUSTOMER_LOCATION_ID_KEY';

interface ICustomerLocationId {
  customerLocationId: number | undefined;
  setCustomerLocationId: (customerLocationId: number | undefined) => void;
}

const useCurrentCustomerLocationId = create(
  persist<ICustomerLocationId>(
    set => ({
      customerLocationId: undefined,
      setCustomerLocationId: (customerLocationId: number | undefined) => {
        try {
          const authData = JSON.parse(localStorage.getItem('auth_data')!);
          authData._customer_location_id = customerLocationId;
          localStorage.setItem('auth_data', JSON.stringify(authData));
        } catch (err) {}

        queryClient.invalidateQueries({
          refetchType: 'all',
        });

        set({ customerLocationId });
      },
    }),
    {
      name: CUSTOMER_LOCATION_ID_KEY,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useCurrentCustomerLocationId;
